import { createSlice } from "@reduxjs/toolkit";
import {
  deleteRelation,
  getRelation,
  undoDeleteRelation,
} from "./relation.api";

const relationSlice = createSlice({
  name: "relation",
  initialState: {
    relation: [],
    loading: false,
    error: null,
    success: null,
    dataLimit: 0,
    currentPage: 0,
    totalPages: 0,
    totalData: 0,
  },
  reducers: {
    resetState: (state) => {
      state.loading = false;
      state.error = null;
      state.success = null;
    },
    updateLocalOrder: (state, action) => {
      state.surname.data = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getRelation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(getRelation.fulfilled, (state, action) => {
      state.loading = false;
      state.relation = action.payload;
      state.dataLimit = action.payload.meta.limit;
      state.currentPage = action.payload.meta.page;
      state.totalPages = action.payload.meta.totalPages;
      state.totalData = action.payload.meta.total;
    });
    builder.addCase(getRelation.rejected, (state, action) => {
      state.loading = false;
    });

    builder.addCase(deleteRelation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(deleteRelation.fulfilled, (state, action) => {
      const deletedId = action.payload.data._id;

      if (state.relation.data) {
        state.relation.data = state.relation.data.filter((relation) => {
          return relation._id !== deletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.relation.data is not an array:",
          state.relation.data
        );
      }
      state.loading = false;
    });
    builder.addCase(deleteRelation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });

    builder.addCase(undoDeleteRelation.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(undoDeleteRelation.fulfilled, (state, action) => {
      const undodeletedId = action.payload.data._id;

      if (state.relation.data) {
        state.relation.data = state.relation.data.filter((relation) => {
          return relation._id !== undodeletedId;
        });
        state.loading = false;
      } else {
        console.error(
          "state.relation.data is not an array:",
          state.relation.data
        );
      }
      state.loading = false;
    });
    builder.addCase(undoDeleteRelation.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload;
    });
  },
});

export const { resetState } = relationSlice.actions;
export default relationSlice.reducer;
